// extracted by mini-css-extract-plugin
export default {"content":"OperationDetails_content__GjxxD"};